// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__NA1y2","l1":"loader_l1__miJnL"};